import { FormFields, FormValidationSchema } from '@/common/interfaces';

export enum SearchConsoleAccountsFormFirstStepInputs {
  Email = 'email',
  Password = 'password',
  BackupEmailAddress = 'backupEmailAddress',
  Provider = 'provider'
}

export enum SearchConsoleAccountsFormSecondStepInputs {
  ClientId = 'clientId',
  ClientSecret = 'clientSecret'
}

export type SearchConsoleAccountsFormFirstStepFields = FormFields<typeof SearchConsoleAccountsFormFirstStepInputs>;

export type SearchConsoleAccountsFormSecondStepFields = FormFields<typeof SearchConsoleAccountsFormSecondStepInputs>;

export type SearchConsoleAccountsFormFirstStepValidationSchema = FormValidationSchema<SearchConsoleAccountsFormFirstStepFields>;

export type SearchConsoleAccountsFormSecondStepValidationSchema = FormValidationSchema<SearchConsoleAccountsFormSecondStepFields>;

export type SearchConsoleAccountFormFields =
  Omit<SearchConsoleAccountsFormFirstStepFields, 'email'>
  & SearchConsoleAccountsFormSecondStepFields;

export enum SearchConsoleAccountsGatewayKeys {
  UpdateTokenStatus = 'updateTokenStatus'
}

export enum SearchConsoleAccountOTPInputs {
  Secret = 'secret',
}

export type SearchConsoleAccountOTPFields = FormFields<typeof SearchConsoleAccountOTPInputs>;

export type SearchConsoleAccountOTPInputsValidationSchema = FormValidationSchema<SearchConsoleAccountOTPFields>;
